import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import {Portal} from '../../../util';
import {GetDocSizeName} from './doc-size-pulse';
import {selectDocSize} from '../../selection/doc-size';
import {allowsAutomatedDocSizes} from './document-sizing';

const Category: React.FC = observer(() => {
    const save = selectDocSize;

    if (!allowsAutomatedDocSizes(s.prod, s.si.AutomatedDocSizes) || !s.docsizes_available || s.docsizes_available.length < 2) {
        return null;
    }

    return (
        <div
            className="gray-box category-container"
            id="doc-size-selection"
        >
            <div>
                <span
                    className="header-std"
                    style={{paddingRight: '0.25rem'}}
                >
                    Degree Selection
                </span>

                {s.docsizes_available.length < 6 && (
                    <div
                        className="cat-prod"
                        role="listbox"
                        aria-label="Select the document size"
                    >
                        {s.docsizes_available.map((m, i) => (
                            <div
                                key={i}
                                title={m.DocSizeName}
                                aria-label={`Select the ${GetDocSizeName(m)} document size`}
                                className={`cust-entity${s.docsizes_selected_id === m.Id ? ' active' : ''}`}
                                onClick={() => save(m.Id)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        save(m.Id);
                                    }
                                }}
                                role="option"
                                tabIndex={0}
                            >
                                <div className="title">
                                    {GetDocSizeName(m)}
                                    {m.Id === s.docsizes_orig_id && s.__fast_ship_orig && (
                                        <div className={`prod-fast-shipping fast-shipping-${Portal?.PortalID}`}>
                                            <i className={Portal?.PortalID !== 3 ? `fas fa-shipping-fast` : `fas fa-cart-shopping-fast`}></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {s.docsizes_available.length > 5 && (
                    <select
                        className="cust-entity form-select ib"
                        aria-label="Select document size"
                        value={s.docsizes_selected_id}
                        onChange={e => save(parseInt(e.target.value, 10))}
                    >
                        {s.docsizes_available.map((m, i) => (
                            <option
                                key={i}
                                value={m.Id}
                            >
                                {GetDocSizeName(m)}
                            </option>
                        ))}
                    </select>
                )}
            </div>
        </div>
    );
});

export default Category;
